import { Controller } from "@hotwired/stimulus"
import { UsbManager } from "../lib/usb"

// Manages Web USB device connection for non-MIDI controllers.

export default class extends Controller {
  static targets = ["status"]

  declare statusTarget: HTMLElement

  private usb = new UsbManager()

  async requestDevice(): Promise<void> {
    const device = await this.usb.requestDevice()
    if (device) {
      this.statusTarget.textContent = `Found: ${device.productName}`
    } else {
      this.statusTarget.textContent = "No device selected"
    }
  }

  async connect(): Promise<void> {
    const ok = await this.usb.connect()
    this.statusTarget.textContent = ok ? "Connected" : "Connection failed"
  }

  async disconnect(): Promise<void> {
    await this.usb.disconnect()
    this.statusTarget.textContent = "Disconnected"
  }
}
